import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading } from '../../../../../components';
import { DatabaseOutlined } from '@ant-design/icons';
import { Col, Form, Row, Input, Select, Button, PageHeader, message, Card, Breadcrumb } from 'antd';
import { detailLanguageSkills, unmountDetailLanguageSkills, updateLanguageSkills } from '../../../../../redux/actions/master/languageSkills/languageSkillsAction';
const { Option } = Select;

class EditMasterLanguageSkill extends Component {
  formRef = React.createRef()
  constructor(props) {
    super(props)
  
    this.state = {
      submitLoading: false
    }
  }

  componentDidMount() {
    const { actionGetDetail, match: { params } } = this.props;
    return actionGetDetail(params.id)
  }

  onFinish = (values) => {
    const { actionUpdate, history, getData: { data } } = this.props;
    values.id = data.id
    this.setState({ submitLoading: true })
    return actionUpdate(values, () => {
      this.setState({ submitLoading: false }, () => {
        message.success('Data updated successfully')
        history.push('/master/language-skills')
      })
    }, (err) => {
      this.setState({ submitLoading: false }, () => {
        message.error(err.message)
      })
    })
  }

  handleChangeCode = (_,val) => {
    this.formRef.current.setFieldsValue({
      name: val.levelName
    })
  }

  render() {
    const { getData: { loading, data } } = this.props;
    const { submitLoading } = this.state;

    if(loading){
      return <Loading />
    }

    return (
      <React.Fragment>
        <Form ref={this.formRef} onFinish={this.onFinish} layout="vertical">
          <Row style={{ position: 'sticky', zIndex: 1, width: '100%', top: 62, right: 0, marginTop: -20, marginBottom: 8, paddingBottom: 12, paddingTop: 16, backgroundColor: '#f2f2f2' }}>
            {/* Breadcrumb */}
            <Col span={24}>
              <Breadcrumb>
                <Breadcrumb.Item><DatabaseOutlined /> Master Data</Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link className="link" to="/master/language-skills">
                    Master Data List Language Skills
                  </Link> 
                </Breadcrumb.Item>
                <Breadcrumb.Item>Language Skills</Breadcrumb.Item>
                <Breadcrumb.Item>{data.name}</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            { /* Page Header */}
            <Col span={24}>
              <PageHeader className="site-page-header" title="Update Language Skills" />
              <PageHeader 
                className="site-page-header" 
                title="Update Language Skills"
                extra={[
                  <Button key="2" className="btn-save-primary" type="default" onClick={() => window.history.back()}>Cancel</Button>,
                  <Button key="1" className="btn-save-primary" type="primary" htmlType="submit" loading={submitLoading}>Update</Button>
                ]}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            { /* Form */}
            <Col span={24}>
              <Card>
                <Row gutter={16}>
                <Col span={12}>
                    <Form.Item 
                      label="Scope" 
                      name="scope" 
                      initialValue={data.scope ? data.scope : ''}
                      rules={[
                        { required: true, message: 'This is a required field' },
                      ]}
                    >
                       <Select
                        showSearch
                        placeholder="Select a scope"
                       >
                        <Option key="1" value="UNDERSTANDING">Understanding</Option>
                        <Option key="2" value="SPEAKING">Speaking</Option>
                        <Option key="3" value="WRITING">Writing</Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Section" 
                      name="section" 
                      initialValue={data.section ? data.section : ''}
                      rules={[
                        { required: true, message: 'This is a required field' },
                      ]}
                    >
                       <Select>
                        <Option key="1" value="LISTENING">Listening</Option>
                        <Option key="2" value="READING">Reading</Option>
                        <Option key="3" value="SPOKEN_INTERACTION">Spoken Interaction</Option>
                        <Option key="4" value="SPOKEN_PRODUCTION">Spoken Production</Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Code" 
                      name="code" 
                      initialValue={data.code ? data.code : ''}
                      rules={[
                        { required: true, message: 'This is a required field' },
                      ]}
                    >
                       <Select onChange={this.handleChangeCode} placeholder="Select a code">
                        <Option key="A1" value="A1" levelName='Basic User'>A1</Option>
                        <Option key="A2" value="A2" levelName='Basic User'>A2</Option>
                        <Option key="B1" value="B1" levelName='Independent User'>B1</Option>
                        <Option key="B2" value="B2" levelName='Independent User'>B2</Option>
                        <Option key="C1" value="C1" levelName='Proficient User'>C1</Option>
                        <Option key="C2" value="C2" levelName='Proficient User'>C2</Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Level Name" 
                      name="name"
                      initialValue={data.name ? data.name : ''}
                      rules={[
                        { max: 100, message: 'Address is too long. Maximum is 100 characters' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item 
                      label="Description in English" 
                      name="descriptionEng" 
                      initialValue={data.descriptionEng ? data.descriptionEng : ''}
                      rules={[
                        { required: true, message: 'This is a required field' },
                        { min: 10, message: 'At least 10 characters'},
                        { max: 1000, message: '1,000 characters only' },
                      ]}
                    >
                      <Input.TextArea rows={3} />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item 
                      label="Description in Bahasa" 
                      name="descriptionIdn" 
                      initialValue={data.descriptionIdn ? data.descriptionIdn : ''}
                      rules={[
                        { required: true, message: 'This is a required field' },
                        { min: 10, message: 'At least 10 characters'},
                        { max: 1000, message: '1,000 characters only' },
                      ]}
                    >
                      <Input.TextArea rows={3} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    )
  }
  componentWillUnmount() {
    const { unmountGetDetail } = this.props;
    return unmountGetDetail()
  }
}

const mapStateToProps = (state) => ({
  getData : state.languageSkills.detail
})

const mapDispatchToProps = {
  actionGetDetail   : detailLanguageSkills,
  actionUpdate      : updateLanguageSkills,
  unmountGetDetail  : unmountDetailLanguageSkills
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMasterLanguageSkill)
